import "../../../shared/accessibility.js";
import "../../../shared/client/jst.js";
import "../../../shared/events.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotPickerModal ??= {};
window.AppointmentBooking.SlotPickerModal.Views ??= {};

AppointmentBooking.SlotPickerModal.Views.Base = class Base extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.contextForRender = this.contextForRender.bind(this);
    this.clearContents = this.clearContents.bind(this);
    this.replaceContents = this.replaceContents.bind(this);
    this.I18n = this.I18n.bind(this);
    this.testIds = this.testIds.bind(this);
  }

  initialize() {
    return window.Sparkle.Accessibility.clickableWithKeyboard(this.$el);
  }

  render() {
    const template = window.Sparkle.Client.jstTemplate(this.template);
    this.replaceContents(this.$el, template(this.contextForRender()));
    Sparkle.Events.contentUpdated(this.el);

    return this;
  }

  contextForRender() {
    const context = {
      classNames(options) {
        return _.chain(options)
          .pick((value) => value)
          .keys()
          .join(" ")
          .value();
      },
      selected(predicate) {
        if (predicate) {
          return 'selected="selected"';
        } else {
          return "";
        }
      },
      I18n: this.I18n(),
      testIds: this.testIds(),
    };

    jQuery.extend(
      context,
      typeof this.model?.defaults === "function" ? this.model.defaults() : undefined,
      this.model != null ? this.model.toJSON() : undefined,
    ); // Defaults are included in case a model attribute has been set to `undefined`, which would cause the key not to appear in the context sent to the template.
    return context;
  }

  clearContents() {
    return this.replaceContents(this.el, "");
  }

  replaceContents(target, ...newContents) {
    target = typeof target === "string" ? this.$el.find(target) : jQuery(target);
    target.children().detach(); // Don't blow away event handlers on subviews
    target.empty(); // Remove any text nodes
    return newContents.forEach((content) => target.append(content));
  }

  I18n() {
    return AppointmentBooking.config.i18n.slot_picker_modal;
  }

  testIds() {
    return AppointmentBooking.config.test_ids;
  }
};
